// extracted by mini-css-extract-plugin
export default {"hidden":"bP3jyL","pin":"v79xFZ","pin-center":"yXfjoS","map":"NFQWB0"};